import React from "react";
import "./sevapage.css";

const sevaList = [
  {
    title: "सेवेअंतर्गत मासिक गुंतवणूक",
    desc: "बँकेत जमा केलेली रक्कम साधारण १५ ते ५० टक्क्यांपर्यंत (लाभांश) देय आहे. नवीन गुंतवणूकदारांसाठी लाभांश दरवर्षी १५%. किमान रक्कम रु. १०००."
  },
  {
    title: "सेवेअंतर्गत मासिक गुंतवणूक",
    desc: "बँकेत जमा केलेली रक्कम साधारण १५ ते ५० टक्क्यांपर्यंत (लाभांश) देय आहे. नवीन गुंतवणूकदारांसाठी लाभांश दरवर्षी १५%. किमान रक्कम रु. १०००."
  },
  {
    title: "सेवेअंतर्गत मासिक गुंतवणूक",
    desc: "बँकेत जमा केलेली रक्कम साधारण १५ ते ५० टक्क्यांपर्यंत (लाभांश) देय आहे. नवीन गुंतवणूकदारांसाठी लाभांश दरवर्षी १५%. किमान रक्कम रु. १०००."
  }
];

function SevaPage() {
  return (
    <div className="seva-container">
        <div className="banner">
        <img src="/images/slider1.jpg" alt="Banner" />
      </div>
      <h2 className="seva-title">आमच्या सेवा</h2>
      <p className="seva-subtitle">
        सर्व बँकिंग सेवा एकाच छताखाली पुरवल्या जातात. 
        काही ठळक सेवा खालीलप्रमाणे :      
      </p>

      <div className="seva-list">
        {sevaList.map((item, index) => (
          <div key={index} className="seva-card">
            <div className="seva-content">
              <button className="seva-btn">{item.title}</button>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SevaPage;
